import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {ChevronLeftIcon} from "../../styles/icons";
import {useNavigate, useLocation} from "react-router-dom";

const BackButton = ({fill, className, sx, text, onNavigate, variant}) => {

  const navigate = useNavigate();
  const location = useLocation();

  const onClickHandler = () => {
    if (onNavigate) {
      onNavigate();
    } else {
      navigate(location.key !== 'default' ? -1 : '/')
    }
  };

  const defaultIcon = {
    fill: fill ?? 'var(--primary)',
    width: '16px',
    height: '16px'
  };

  return (
    <Button
      onClick={onClickHandler}
      className={className}
      variant={variant}
      sx={sx}
    >
      <ChevronLeftIcon fill={defaultIcon.fill} width={defaultIcon.width} height={defaultIcon.height} />
      <Typography variant='body' sx={{marginLeft: '5px'}}>
        {text ?? 'Back'}
      </Typography>
    </Button>
  );
};

export default BackButton;
